import signedFetch from './util/signedFetch.js';

export default function* getActivationCodeDetails(code) {
  const URL = `${__API_BASE__}/admin-console/${code}/details`;
  return yield signedFetch('getActivationCodeDetails', URL, 'GET');
}
